import React, { useState } from 'react'

import { Edit as EditIcon, Home as HomeIcon, Print as PrintIcon } from '@material-ui/icons'

import { useAsyncPrint } from 'src/components/ToPrint/useAsyncPrint'
import { TruckloadLabel } from 'src/modules/supply_chain/components/freight/TruckloadLabel'
import { TruckloadShippingManifest } from 'src/modules/supply_chain/components/freight/TruckloadShippingManifest'
import { TruckloadDialog } from 'src/modules/supply_chain/components/freight/TruckloadDialog'
import {
  LinkedPathField,
  StatusField,
  RelatedLinkedField,
  TruckloadAppointmentField,
  ValueField,
} from 'src/components/Table'
import { DetailComponent } from './base'

interface ObjInfo {
  data: any
  isLoading: boolean
  refetch: () => void
}

interface DetailTableProps {
  obj: ObjInfo
  refresh?: () => void
  customFields?: Record<string, string>
}

export const TruckloadDetailTable = (props: DetailTableProps) => {
  const { obj, refresh, customFields } = props
  const [updateOpen, setUpdateOpen] = useState(false)
  const { print: asyncPrint, renderPrintComponent: renderAsyncPrintComponent } = useAsyncPrint()

  return (
    <>
      {renderAsyncPrintComponent()}
      {updateOpen && (
        <TruckloadDialog
          open={updateOpen}
          truckload={obj.data}
          update
          handleClose={() => {
            setUpdateOpen(false)
          }}
          onSave={refresh}
        />
      )}
      <DetailComponent
        obj={obj}
        Icon={HomeIcon}
        menuItems={[
          {
            Icon: EditIcon,
            actions: [{ title: 'Edit Truckload', onClick: () => setUpdateOpen(true) }],
          },
          {
            Icon: PrintIcon,
            actions: [
              {
                title: 'Print Truckload',
                onClick: () =>
                  asyncPrint((props) => <TruckloadLabel {...props} truckload={obj.data} />),
              },
              {
                title: 'Print Shipping Manifest',
                onClick: () =>
                  asyncPrint((props) => (
                    <TruckloadShippingManifest {...props} truckload={obj.data} />
                  )),
              },
              {
                title: 'Print All',
                onClick: () =>
                  asyncPrint((props) => (
                    <>
                      <TruckloadLabel truckload={obj.data} />
                      <TruckloadShippingManifest {...props} truckload={obj.data} />
                    </>
                  )),
              },
            ],
          },
        ]}
        fields={[
          { id: 'guid', label: 'SquID', renderer: ValueField },
          { id: 'trackingNumber', label: 'Tracking Number', renderer: ValueField },
          { id: 'billOfLadingNumber', label: 'Bill of Lading Number', renderer: ValueField },
          { id: 'trailerNumber', label: 'Trailer Number', renderer: ValueField },
          { id: 'client', label: 'Client', renderer: RelatedLinkedField(ValueField, 'name') },
          {
            id: 'facility',
            label: 'Facility',
            renderer: RelatedLinkedField(ValueField, 'name'),
          },
          {
            id: 'objPath',
            label: 'Path',
            renderer: LinkedPathField,
          },
          { id: 'carrier', label: 'Carrier', renderer: RelatedLinkedField(ValueField, 'name') },
          { id: 'status', label: 'Status', renderer: StatusField },
          {
            id: 'appointment',
            label: 'Appointment',
            renderer: TruckloadAppointmentField({ refresh: obj.refetch }),
          },
        ]}
        customFields={customFields}
      />
    </>
  )
}
